module.exports = __webpack_public_path__ + "img/explainable-ai.6ccb9fab.jpg";